import { featureFlag, IFeatureFlagUserAttributes } from '../../utils';
import { JSONValue, WidenPrimitives } from '@growthbook/growthbook';

/**
 * Hook to use feature flags throughout the application
 * @returns Object with feature flag functions
 */
export const useFeatureFlag = () => {
  /**
   * Get the value of a feature flag
   * @param key - The feature flag key
   * @param fallbackValue - The default value if the feature flag is not defined
   * @returns The feature flag value
   */
  const getFeatureValue = <T extends JSONValue>(
    key: string,
    fallbackValue: T
  ): WidenPrimitives<T> => {
    return featureFlag.getFeatureValue(key, fallbackValue);
  };

  const initFeatureFlag = async (
    userAttributes: IFeatureFlagUserAttributes
  ): Promise<void> => {
    await featureFlag.init(userAttributes);
  };

  const updateAttributes = async (
    partial: Record<string, unknown>
  ): Promise<void> => {
    await featureFlag.updateAttributes(partial);
  };

  return {
    initFeatureFlag,
    getFeatureValue,
    updateAttributes,
  };
};
